var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      staticClass: "job-profile-readonly",
      class: _vm.expand === true ? "" : "bordered"
    },
    [
      _vm.expand === false
        ? _c(
            "button",
            {
              staticClass: "button small",
              class: _vm.expanded ? "expanded" : "collapsed",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.expanded = !_vm.expanded
                }
              }
            },
            [_vm._v(_vm._s(_vm.expanded ? "Collapse" : "Expand"))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell low-opacity",
              class: _vm.compact === true ? "auto" : "medium-6 large-4"
            },
            [
              _c("label", [_vm._v("Job Profile Title *")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "textarea",
                domProps: {
                  innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.title))
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.inputsClickable
            ? _c("input-emit-button", {
                on: {
                  click: function() {
                    return _vm.$emit(
                      "input-clicked",
                      "Job Profile Title",
                      _vm.jobProfile.title
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell low-opacity",
              class: _vm.compact === true ? "auto" : "medium-6 large-4"
            },
            [
              _c("label", [_vm._v("Reporting To")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "textarea",
                domProps: {
                  innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.reporting_to))
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.inputsClickable
            ? _c("input-emit-button", {
                attrs: { "container-class": "cell small-2" },
                on: {
                  click: function() {
                    return _vm.$emit(
                      "input-clicked",
                      "Reporting To",
                      _vm.jobProfile.reporting_to
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell low-opacity",
              class: _vm.compact === true ? "auto" : "medium-6 large-4"
            },
            [
              _c("label", [_vm._v("Job Purpose")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "textarea",
                domProps: {
                  innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.purpose))
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.inputsClickable
            ? _c("input-emit-button", {
                attrs: { "container-class": "cell small-2" },
                on: {
                  click: function() {
                    return _vm.$emit(
                      "input-clicked",
                      "Purpose",
                      _vm.jobProfile.purpose
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.twoColumn
        ? _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c("div", { staticClass: "cell low-opacity medium-4" }, [
                  _c("label", [_vm._v("Key Performance Indicators")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "html-content",
                    domProps: {
                      innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.kpi))
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Key Performance Indicators",
                            _vm.jobProfile.kpi
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "cell low-opacity medium-4" }, [
                  _c("label", [_vm._v("Knowledge")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "html-content",
                    domProps: { innerHTML: _vm._s(_vm.jobProfile.knowledge) }
                  })
                ]),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Knowledge",
                            _vm.jobProfile.knowledge
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c("div", { staticClass: "cell low-opacity medium-4" }, [
                  _c("label", [_vm._v("Skills")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "html-content",
                    domProps: {
                      innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.skills))
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Skills",
                            _vm.jobProfile.skills
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "cell low-opacity medium-4" }, [
                  _c("label", [_vm._v("Attributes")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "html-content",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.removePTag(_vm.jobProfile.attributes)
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Attributes",
                            _vm.jobProfile.attributes
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Key Performance Indicators")]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "html-content",
                      domProps: {
                        innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.kpi))
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Key Performance Indicators",
                            _vm.jobProfile.kpi
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Knowledge")]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "html-content",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.removePTag(_vm.jobProfile.knowledge)
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Knowledge",
                            _vm.jobProfile.knowledge
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Skills")]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "html-content",
                      domProps: {
                        innerHTML: _vm._s(_vm.removePTag(_vm.jobProfile.skills))
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Skills",
                            _vm.jobProfile.skills
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Attributes")]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "html-content",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.removePTag(_vm.jobProfile.attributes)
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Attributes",
                            _vm.jobProfile.attributes
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c4bf804", { render: render, staticRenderFns: staticRenderFns })
  }
}